export default () => ({
  entities: 'statistics',
  statistics: [],
  total: 0
})



// WEBPACK FOOTER //
// ./src/app/team/dashboard/gadget/components/summary-billing/resources/data.js